import { autoinject } from "aurelia-framework";
import { AdditionalFieldsSourceType } from "enums/additional-fields-source-type";

import additionalFieldsService from "services/additionalFieldsService";
import routerHelper from "helpers/routerHelper";
import { FormBase } from "pages/form-base";
import { AdditionalFieldMapper } from "components/pages/additional-fields/helpers/additional-field-mapper";
import { NotificationHelper } from "helpers/notification-helper";
import { Router } from "aurelia-router";
import { I18N } from "aurelia-i18n";

@autoinject()
export class FieldServiceMaterialOrderAdditonnalFields extends FormBase {
    public actions: any = {};
    public workOrderId: string = "";
    public orderId: string = "";
    public readonly: boolean = true;
    public extension: string = "";
    public additionalFieldsSource: number = AdditionalFieldsSourceType.PurchaseOrder;
    public saveAdditionalFieldsButton: boolean = false;
    public currentFields: any = null;
    public unModifiedFields: any = null;

    constructor(i18n: I18N,  notificationHelper: NotificationHelper, router: Router, private readonly additionalFieldMapper: AdditionalFieldMapper) {
        super(notificationHelper, i18n, router);
    }

    public activate(params: any): any {
        this.bindViewModel(decodeURIComponent(params.workOrderId), params.orderId, params.q);
        this.bindWidget();
    }

    public checkDirty(): boolean {
        if (this.readonly) {
            return false;
        }

        return this.additionalFieldMapper.isNotEqual(this.unModifiedFields, this.currentFields);
    }

    private bindViewModel(workOrderId: string, orderId: string, queryString: string): void {
        const params = routerHelper.getQuerystring(queryString);
        this.readonly = !(params && params.readonly === "false");
        this.extension = params.extension;

        this.saveAdditionalFieldsButton = !this.readonly;
        this.workOrderId = workOrderId;
        this.orderId = orderId;
    }

    private bindWidget(): void {
        this.actions = {
            getAll: additionalFieldsService.getAllForPurchaseOrder.bind(this, this.orderId, this.extension),
            setAll: additionalFieldsService.setAllForPurchaseOrder.bind(this, this.orderId, this.extension)
        };
    }
}
